import { render, staticRenderFns } from "./SignUpBottom.vue?vue&type=template&id=acf343f4&lang=html"
import script from "./SignUpBottom.vue?vue&type=script&lang=js"
export * from "./SignUpBottom.vue?vue&type=script&lang=js"
import style0 from "./SignUpBottom.vue?vue&type=style&index=0&id=acf343f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports